__turbopack_context__.v({
  "actions": "Header-Images-module-scss-module__xzjqUq__actions",
  "card": "Header-Images-module-scss-module__xzjqUq__card",
  "control": "Header-Images-module-scss-module__xzjqUq__control",
  "controls": "Header-Images-module-scss-module__xzjqUq__controls",
  "counter": "Header-Images-module-scss-module__xzjqUq__counter",
  "slide": "Header-Images-module-scss-module__xzjqUq__slide",
});
